import React, { useContext, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { ALIGN, NewTable, SORT, WrapperCardContent } from '../../../../../components/datatable/NewTable'
import useBoolean from '../../../../../utils/customHook/useBoolean'
import { getDate } from '../../../../../utils/DateUtil'
import { getPlanningProducersName, negIdGenerator } from '../../../../utils/CampaignUtils'
import PopinCampaignPlanning from './PopinCampaignPlanning'
import { StationCampaignContext } from '../../DashboardCampaign'

const headers = ['startDate', 'endDate', 'completion', 'nbStations', 'nbObjectives', 'nbExceptions']

const TableCampaignPlannings = () => {
    const {
        isEditMode,
        campaignPlannings, setCampaignPlannings,
        campaignPlanningsExceptions, setCampaignPlanningsExceptions,
        onExportPlanning,
    } = useContext(StationCampaignContext)

    const {
        contacts,
    } = useSelector(store => ({
        contacts: store.ContactReducer.contacts,
    }), shallowEqual)

    const { value: isOpen, setTrue: onOpen, setFalse: onClose } = useBoolean(false)
    const [selectedPlanningIndex, setSelectedPlanningIndex] = useState()

    const formattedPlannings = campaignPlannings.map(planning => ({
        startDate: { value: getDate(planning.startDate), sortValue: planning.startDate },
        endDate: { value: getDate(planning.endDate), sortValue: planning.endDate },
        completion: getPlanningProducersName(planning, contacts),
        nbStations: `${planning.stationsPlan.length}`,
        nbObjectives: `${planning.objectivesPlan.length}`,
        nbExceptions: campaignPlanningsExceptions.filter(({ planningId }) => planningId === planning.id).length,
    }))

    const onUpdate = (index, newPlanning, newPlanningExceptions) => {
        setCampaignPlannings(prev => prev.toSpliced(index, 1, newPlanning))
        setCampaignPlanningsExceptions(prev => [
            ...prev.filter(({ planningId }) => planningId !== campaignPlannings[index].id),
            ...newPlanningExceptions,
        ])
    }

    const onDuplicate = (index) => {
        const newPlanningId = negIdGenerator.next().value
        setCampaignPlannings(prev => [...prev, { ...prev[index], id: newPlanningId }])
        setCampaignPlanningsExceptions(prev => [
            ...prev,
            ...prev
                .filter(({ planningId }) => planningId === campaignPlannings[index].id)
                .map(exception => ({ ...exception, id: undefined, planningId: newPlanningId })),
        ])
    }

    const onDelete = (index) => {
        setCampaignPlanningsExceptions(prev => prev.filter(({ planningId }) => planningId !== campaignPlannings[index].id))
        setCampaignPlannings(prev => prev.toSpliced(index, 1))
    }

    return (
        <>
            <NewTable
                rows={formattedPlannings}
                headers={headers}
                lineActions={[{
                    icon: 'visibility',
                    onClick: (_, index) => {
                        setSelectedPlanningIndex(index)
                        onOpen()
                    },
                    displayed: !isEditMode,
                }, {
                    icon: 'close',
                    onClick: (_, index) => onDelete(index),
                    displayed: isEditMode,
                }, {
                    icon: 'add_to_photos',
                    onClick: (_, index) => onDuplicate(index),
                    displayed: isEditMode,
                }, {
                    icon: 'edit',
                    onClick: (_, index) => {
                        setSelectedPlanningIndex(index)
                        onOpen()
                    },
                    displayed: isEditMode,
                }, {
                    icon: 'file_download',
                    onClick: (_, index) => onExportPlanning(campaignPlannings[index].id),
                    tooltip: i18n.export,
                    align: ALIGN.RIGHT,
                }]}
                defaultSort={{ column: 'startDate', direction: SORT.ASC }}
                WrapperComponent={WrapperCardContent}
            />
            {isOpen && (
                <PopinCampaignPlanning
                    isOpen={isOpen}
                    onClose={onClose}
                    onValidate={(newPlanning, newPlanningExceptions) => {
                        onUpdate(selectedPlanningIndex, newPlanning, newPlanningExceptions)
                        onClose()
                    }}
                    campaignPlanning={campaignPlannings[selectedPlanningIndex]}
                    campaignPlanningExceptions={campaignPlanningsExceptions.filter(({ planningId }) => planningId === campaignPlannings[selectedPlanningIndex]?.id)}
                    isEditMode={isEditMode}
                    onExport={() => onExportPlanning(campaignPlannings[selectedPlanningIndex].id)}
                />
            )}
        </>
    )
}

export default TableCampaignPlannings
